t = require('app/scripts/views/internal/teacup-with-helpers')('embedly')

module.exports = ->
  t.div { class: 'embed embed-' + t.mustacheVar('type') + ' embed-provider-' + t.mustacheVar('provider_name') }, ->
    t.mustacheBlockInverted 'type_photo', ->
      t.mustacheBlock 'requireHttps', ->
        t.raw t.mustacheVar('htmlHttps')
      t.mustacheBlockInverted 'requireHttps', ->
        t.raw t.mustacheVar('html')
    t.mustacheBlock 'type_photo', ->
      t.a { href: t.mustacheVar('originalUrl'), target: '_blank' }, ->
        t.img { src: t.mustacheVar('url') }
